import { Button } from '@synergy-marine-group/synergy-ui';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import Modal from 'react-responsive-modal';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import getFullVesselList from '../po/queries/getAllVesselList';
import getVendorList from '../vendor/queries/getVendorList';
import getVesselOwnerList from '../vendor/queries/getVesselOwnerList';
import { POModalStyles } from './styles';
import { updateFliter } from '../../features/fliter/filterSlice';
import { updatepage } from '../../features/pagecount/pageSlice';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import getVendorDashboardVendorList from '../vendor/queries/getVendorDashBoardFilterVendorList';
import getExpenseCategoryJSONlist from '../po/queries/getExpenseCategoryJsonList';
import { filterExpenseCategoriesByPoListType } from '../po/utils';

const emptyDataObj = {
  crewID: null,
  vessel: null,
  vendor: null,
  poStatus: null,
  poInitiator: null,
  invoiceStatus: null,
  vesselOwner: null,
  budgetCategory: null,
  todate: null,
  fromdate: null,
  shortCloseStatus: null,
  serviceFromDate: null,
  serviceToDate: null,
  plannedVesselRevisionId: null,
  expenseCategoryId: null,
  expenseCategoryName: null
};

const basePoStatusList = [
  { label: 'Draft', value: 0 },
  { label: ' Submitted', value: 1 },
  { label: 'Short Closed', value: 2 },
  { label: 'Amended', value: 3 },
  { label: 'Open PO', value: 4 },
  { label: 'Closed', value: 5 },
  { label: 'Partially Closed', value: 6 },
  { label: 'Paid', value: 7 }
];

const agencyOnlyStatuses = [
  { label: 'Initiated', value: 18 },
  { label: 'Level1Approved', value: 19 }
];

const invoiceList = [
  { label: 'Transferred', value: 0 },
  { label: 'Voucher Created', value: 1 },
  { label: 'Payment Made', value: 2 },
  { label: 'Apportioned', value: 4 },
  { label: 'Pending', value: 3 }
];

const baseBudgetCategoryList = [
  { label: 'BUDGETED CATEGORY', value: 'BUDGETED CATEGORY' },
  { label: 'NON-BUDGETED CATEGORY', value: 'NON BUDGETED CATEGORY' },
  { label: 'PRE-DELIVERY CATEGORY (TAKEOVER)', value: 'PRE DELIVERY CATEGORY' },
  { label: 'HANDOVER CATEGORY', value: 'HANDOVER CATEGORY' },
  { label: 'DRY DOCK', value: 'DRY DOCK' }
];

const agencyOnlyBudgetCategory = [{ label: 'OTHERS', value: 'OTHERS' }];
const shortCloseList = [
  { label: 'Level 1 - Pending', value: 'Level 1 Pending' },
  { label: 'Level 2 - Pending', value: 'Level 2 Pending' },
  { label: 'Level 1 - Approved', value: 'Level 1 Approved' },
  { label: 'Level 2 - Approved', value: 'Level 2 Approved' },
  { label: 'Level 1 - Rejected', value: 'Level 1 Rejected' },
  { label: 'Level 2 - Rejected', value: 'Level 2 Rejected' }
];

const PoFilter = ({ setModal, modal, filterData, dispatch,
   setActiveTab, isVendor, isCrewPage, poListType }) => {
  const isAgencyPage = poListType === 'agency';
  const PoStatusList = isAgencyPage
    ? [...agencyOnlyStatuses, ...basePoStatusList]
    : basePoStatusList;
  const budgetCategoryList = isAgencyPage
    ? [...baseBudgetCategoryList, ...agencyOnlyBudgetCategory]
    : baseBudgetCategoryList;
  const policies = returnPolicies();
  const { data: vessels } = policies?.dropDownAccess ? getFullVesselList() : [];
  const vesselList = formatDropdownOptions(vessels?.data, 'name', 'vesselRevisionId', 'vesselCode', true)?.map((item, index) => ({
    ...item,
    vesselRevisionId: vessels?.data?.[index]?.vesselRevisionId,
    id: vessels?.data?.[index]?.id
  }));

  const { data: vendorData } = isVendor
  ? (policies?.dropDownAccess ? getVendorDashboardVendorList() : { data: [] })
  : (policies?.dropDownAccess ? getVendorList() : { data: [] });
  const vendorDataList = formatDropdownOptions(vendorData?.data, 'vendorName', 'id');
  const { data: vesselOwnerData } = policies?.dropDownAccess ? getVesselOwnerList() : [];
  const vesselOwnerDataList = formatDropdownOptions(vesselOwnerData?.data, 'name', 'id');
  const { data: expenseCategory } = getExpenseCategoryJSONlist();
  const expenseCategoryList = formatDropdownOptions(
    filterExpenseCategoriesByPoListType(expenseCategory?.data, poListType),
    'categoryName',
    'expenseCategoryID'
  );
  const handleSubmit = (data) => {
    const payload = {
      ...data,
      expenseCategoryId: data?.expenseCategoryId != null && data.expenseCategoryId !== ''
        ? String(data.expenseCategoryId)
        : null,
      expenseCategoryName: data?.expenseCategoryName || null
    };
    dispatch(updateFliter(payload));
    if (!isVendor) {
      setActiveTab(payload.poStatus);
    }
    dispatch(updatepage(1));
    setModal(false);
  };

  const handleReset = (restFormProps) => {
    dispatch(updateFliter(emptyDataObj));
    setActiveTab(null);
    restFormProps.setFieldValue('crewID', '');
    restFormProps.setFieldValue('vessel', '');
    restFormProps.setFieldValue('vendor', '');
    restFormProps.setFieldValue('poStatus', '');
    restFormProps.setFieldValue('poInitiator', '');
    restFormProps.setFieldValue('invoiceStatus', '');
    restFormProps.setFieldValue('vesselOwner', '');
    restFormProps.setFieldValue('budgetCategory', '');
    restFormProps.setFieldValue('todate', '');
    restFormProps.setFieldValue('fromdate', '');
    restFormProps.setFieldValue('shortCloseStatus', '');
    restFormProps.setFieldValue('serviceFromDate', '');
    restFormProps.setFieldValue('serviceToDate', '');
    restFormProps.setFieldValue('plannedVesselRevisionId', '');
    restFormProps.setFieldValue('expenseCategoryId', '');
    restFormProps.setFieldValue('expenseCategoryName', '');
    setModal(false);
  };

  return (
    <Modal
      open={modal}
      onClose={() => setModal(false)}
      closeOnOverlayClick
      showCloseIcon={false}
      styles={POModalStyles}
    >
      <Formik initialValues={filterData} onSubmit={(values) => handleSubmit(values)}>
        {({ values, ...restFormProps }) => (
          <Form>
            <div className="w-auto input-default">
              <div className="align-right">
                <div className="grid grid-cols-3 gap-4 pb-7">
                  {isCrewPage && (
                    <Field
                      name="crewID"
                      component={InputFieldComponent}
                      className="w-full"
                      size="large"
                      rounded
                      id="select1"
                      type="text"
                      label="Crew Code"
                      maxMenuHeight={100}
                    />
                  )}
                  <Field
                    name="poInitiator"
                    component={InputFieldComponent}
                    className="w-full"
                    size="large"
                    rounded
                    id="select1"
                    type="text"
                    label="PO Initiator"
                    maxMenuHeight={100}
                  />
                  <Field
                    name="vessel"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={vesselList}
                    size="large"
                    rounded
                    id="select1"
                    label="Vessel"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                    customOnChange={(option, form) => {
                      form.setFieldValue('vessel', option?.id || '');
                      form.setFieldValue('plannedVesselRevisionId', option?.value || '');
                    }}
                    special={
                      vesselList?.find((v) => v.value === values?.plannedVesselRevisionId) || null
                    }
                  />

                  {(!policies?.ppePolicies?.canAccess || policies?.poPolicies?.canEdit) && (
                    <Field
                      name="vendor"
                      component={DropdownFieldComponent}
                      className="w-full"
                      options={vendorDataList}
                      size="large"
                      rounded
                      id="select1"
                      label="Vendor"
                      type="text"
                      maxMenuHeight={200}
                      isClearable
                    />
                  )}

                  <Field
                    name="poStatus"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={PoStatusList}
                    size="large"
                    rounded
                    id="select1"
                    label="PO Status"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                  />

                  <Field
                    name="invoiceStatus"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={invoiceList}
                    size="large"
                    rounded
                    id="select1"
                    label="Line item Status"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                  />

                  <Field
                    name="budgetCategory"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={budgetCategoryList}
                    size="large"
                    rounded
                    id="select1"
                    label="Budget Category"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                  />
                  <Field
                    name="expenseCategoryId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={expenseCategoryList}
                    size="large"
                    rounded
                    id="expenseCategoryId"
                    label="Expense Category"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                    customOnChange={(option, form) => {
                      if (!option) {
                        form.setFieldValue('expenseCategoryId', '');
                        form.setFieldValue('expenseCategoryName', '');
                        return;
                      }
                      const categoryId = option?.value ?? option?.expenseCategoryID ?? '';
                      const categoryName = option?.categoryName ?? option?.label ?? '';
                      form.setFieldValue('expenseCategoryId', categoryId);
                      form.setFieldValue('expenseCategoryName', categoryName);
                    }}
                  />
                    <Field
                    name="vesselOwner"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={vesselOwnerDataList}
                    size="large"
                    rounded
                    id="select1"
                    label="Vessel Owner"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                    />
                  <Field
                    name="fromdate"
                    component={InputFieldComponent}
                    className="w-full"
                    size="large"
                    rounded
                    id="select1"
                    label="From date"
                    type="date"
                    maxMenuHeight={100}
                  />
                  <Field
                    name="todate"
                    component={InputFieldComponent}
                    className="w-full"
                    size="large"
                    rounded
                    id="select1"
                    label="To date"
                    type="date"
                    maxMenuHeight={100}
                  />
                   <Field
                    name="shortCloseStatus"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={shortCloseList}
                    size="large"
                    rounded
                    id="shortCloseStatus"
                    label="Short Close Status"
                    type="text"
                    maxMenuHeight={200}
                    isClearable
                   />
                  {isAgencyPage && (
                    <>
                      <Field
                        name="serviceFromDate"
                        component={InputFieldComponent}
                        className="w-full"
                        size="large"
                        rounded
                        id="serviceFromDate"
                        label="Service Completion From Date"
                        type="date"
                        maxMenuHeight={100}
                      />
                      <Field
                        name="serviceToDate"
                        component={InputFieldComponent}
                        className="w-full"
                        size="large"
                        rounded
                        id="serviceToDate"
                        label="Service Completion To Date"
                        type="date"
                        maxMenuHeight={100}
                      />
                    </>
                  )}

                </div>
                <div className="flex justify-end ">
                  <Button
                    className="max-w-none mr-4 font-montserrat text-gray-500 uppercase text-sm"
                    onClick={() => handleReset(restFormProps)}
                    size="small"
                    variant="outlined"
                    rounded
                  >
                    Reset
                  </Button>

                  <Button className="max-w-none font-montserrat text-gray-500 uppercase text-sm" size="small" variant=" filled" rounded type="submit">
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default PoFilter;
